<template>
	<div>
		<change_courses :perpage="50" ></change_courses>
	</div>
</template>
<script>
import change_courses from '@/components/change_courses'
export default {
	components: {
		change_courses
	},
	data() {
		return {
		}
	},
	// 初始事件
	mounted: function () {
	},
	// 事件
	methods: {
	},
	// 过滤器
	filters: {
	}
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/teacher/inventory.vue